import { graphql } from '@/gql';
import type { CoachingAssignmentsQuery } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export type CoachingAssignmentRow = CoachingAssignmentsQuery['coachingAssignments'][number];

export const fetchCoachingAssignments = async (): Promise<CoachingAssignmentRow[]> => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    query: graphql(`
      query CoachingAssignments {
        coachingAssignments {
          id
          agentId
          operatorId
          startDate
          endDate
          data {
            serviceType
            callerType
          }
          operator {
            id
            firstName
            lastName
          }
        }
      }
    `),
  });
  return response.data?.coachingAssignments ?? [];
};
